function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
  requiredExtensions: "&ns_ai;",
  x: 0,
  y: 0,
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("iPgfRef", {
  xlinkHref: "#adobe_illustrator_pgf"
})), /*#__PURE__*/React.createElement("g", {
  iExtraneous: "self"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeMiterlimit: 10,
  d: "M22.1,25.5H3.9c-0.8,0-1.4-0.9-1.4-1.7L0.7,13.8 c0-0.8,0.6-1.4,1.4-1.4h21.9c0.8,0,1.4,0.6,1.4,1.4l-1.9,10.1C23.5,24.6,22.8,25.5,22.1,25.5z M17,6.9c0-0.8,0.6-1.4,1.4-1.4 h3.4c0.8,0,1.4,0.6,1.4,1.4v5.4 M16.9,6.6v5.7 M13.1,8.9v3.4 M10.1,9v3.4 M3.9,7.8h5 M4,6.2h4.9 M16.9,6.7V2.5 c0-1.1-0.9-2-1.9-2c-1.1,0-1.9,0.9-1.9,2v6.5c-1-0.3-2.1-0.6-3,0.1C9.9,8.7,9.6,8.6,9.4,8.4C9.1,8.1,8.9,8,8.9,7.4V6.2 c0.3-0.2,0.6-0.5,0.6-1V3.8c0-0.6-0.5-1.1-1.1-1.1H4.5c-0.6,0-1.1,0.5-1.1,1.1v1.4c0,0.4,0.2,0.8,0.6,1v1.3c0,0.6-0.2,0.7-0.5,1 c-0.4,0.3-1,0.8-1,2l0,1.9h0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M12.4,19.2H8.9c0-0.1,0-0.2,0-0.3v-0.3v-0.3c0-0.1,0-0.2,0-0.3h3.5v-3.8c0.1,0,0.2,0,0.3,0 c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0v3.8h3.5c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3 c0,0.1,0,0.2,0,0.3h-3.5V23c-0.1,0-0.2,0-0.3,0H13h-0.3c-0.1,0-0.2,0-0.3,0V19.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeMiterlimit: 10,
  d: "M18.3,10.1h3.6 M18.3,8.5h3.6"
}))));

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlnsX: "&ns_extend;",
    xmlnsI: "&ns_ai;",
    xmlnsGraph: "&ns_graphs;",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    enableBackground: "new 0 0 26 26",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.c52e4e49.svg";
export { ForwardRef as ReactComponent };